import { useQuery } from "@tanstack/react-query";
import api from "../../api/api";
import { useDispatch, useSelector } from "react-redux";
import { userLogout } from "../../features/userSlice";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { saveAs } from "file-saver";
import { useOktaAuth } from "@okta/okta-react";

const useDownloadTrainings = (queryIdentifier, targetTable, fileType, searchKeyword, order, orderBy, servicerMasterId) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { authState } = useOktaAuth()
    const accessToken = authState.accessToken.accessToken
    const url = searchKeyword ?
        `/download/${targetTable}?orderBy=${orderBy}&order=${order.toUpperCase()}&searchKeyword=${searchKeyword}`
        :
        `/download/${targetTable}?orderBy=${orderBy}&order=${order.toUpperCase()}`

    const fetchData = async () => {
        const res = await api.get(url, {
            headers: {
                authorization: `Bearer ${accessToken}`,
                fileType
            },
            responseType: 'blob'
        })
        return res.data
    }
    return useQuery(queryIdentifier, fetchData, {
        enabled: false,
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: true,
        onError: (e) => {
            const statusCode = e.response.status
            if (statusCode === 402) {
                dispatch(userLogout())
                navigate('/authentication')
            }
            const { message } = e.response.data
            toast.error(message)
        },
        onSuccess: (data) => {
            let fileExtension = ''
            // download excel
            fileType =
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
            fileExtension = 'xlsx'

            const blob = new Blob([data], { type: fileType })
            saveAs(blob, `${Date.now()}.${fileExtension}`)
        }
    })
}

export default useDownloadTrainings